export enum AuthenticationContentPermission {
    /**
     * Read-only access to all branches
     */
    READ = 'read',
    /**
     * Read-write access to all branches, including the main one.
     */
    WRITE = 'write',
    /**
     * Read-write access to all branches, except the main one.
     */
    WRITE_BRANCH = 'write-branch',
    /**
     * Admin access to all branches, including the main one.
     * Admin permissions should only be used by the backend to perform operations on behalf of the user.
     * It can be used to create operations, delete content, etc.
     */
    ADMIN = 'admin',
}

/**
 * Payload of an authentication token.
 */
export interface AuthenticationTokenPayload {
    /**
     * The ID of the user.
     */
    userId: string;

    /**
     * Content IDs that can be accessed by the user. Supports both contentIds
     * and content patterns. Exact content IDs have a higher priority than
     * pattern matches.
     */
    content: {
        [contentId: string]: AuthenticationContentPermission;
    };
}

/**
 * Returns the highest permission level from a list of permissions.
 */
export function getHighestHivePermissionLevel(
    permissions: AuthenticationContentPermission[]
): AuthenticationContentPermission | undefined {
    if (permissions.includes(AuthenticationContentPermission.ADMIN)) {
        return AuthenticationContentPermission.ADMIN;
    }

    if (permissions.includes(AuthenticationContentPermission.WRITE)) {
        return AuthenticationContentPermission.WRITE;
    }

    if (permissions.includes(AuthenticationContentPermission.WRITE_BRANCH)) {
        return AuthenticationContentPermission.WRITE_BRANCH;
    }

    if (permissions.includes(AuthenticationContentPermission.READ)) {
        return AuthenticationContentPermission.READ;
    }

    return;
}
